import React from 'react';

export const Mail = () => (
  <svg
    width="84"
    height="84"
    viewBox="0 0 84 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42 82.5C64.3675 82.5 82.5 64.3675 82.5 42C82.5 19.6325 64.3675 1.5 42 1.5C19.6325 1.5 1.5 19.6325 1.5 42C1.5 64.3675 19.6325 82.5 42 82.5Z"
      stroke="#00964E"
      strokeWidth="3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 27.5C20.8674 27.5 20.7402 27.5527 20.6464 27.6464C20.5527 27.7402 20.5 27.8674 20.5 28V56C20.5 56.1326 20.5527 56.2598 20.6464 56.3536C20.7402 56.4473 20.8674 56.5 21 56.5H63C63.1326 56.5 63.2598 56.4473 63.3536 56.3536C63.4473 56.2598 63.5 56.1326 63.5 56V28C63.5 27.8674 63.4473 27.7402 63.3536 27.6464C63.2598 27.5527 63.1326 27.5 63 27.5H21Z"
      stroke="#00964E"
      strokeWidth="3"
    />
    <path
      d="M21 28L42 47L63 28M37.07 42.19L21 56M47 42.19L63.07 56"
      stroke="#00964E"
      strokeWidth="3"
    />
  </svg>
);
